var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_551_28391",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_551_28391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 26.667V17.2503C12.264 17.0975 12.0662 16.9031 11.9067 16.667C11.7467 16.4309 11.6667 16.1531 11.6667 15.8337V13.3337C11.6667 12.8753 11.8301 12.4828 12.1567 12.1562C12.4829 11.83 12.8751 11.667 13.3334 11.667H26.6667C27.1251 11.667 27.5176 11.83 27.8442 12.1562C28.1704 12.4828 28.3334 12.8753 28.3334 13.3337V15.8337C28.3334 16.1531 28.2534 16.4309 28.0934 16.667C27.934 16.9031 27.7362 17.0975 27.5001 17.2503V26.667C27.5001 27.1253 27.337 27.5178 27.0109 27.8445C26.6842 28.1706 26.2917 28.3337 25.8334 28.3337H14.1667C13.7084 28.3337 13.3159 28.1706 12.9892 27.8445C12.6631 27.5178 12.5001 27.1253 12.5001 26.667ZM14.1667 17.5003V26.667H25.8334V17.5003H14.1667ZM26.6667 15.8337V13.3337H13.3334V15.8337H26.6667ZM17.5001 21.667H22.5001V20.0003H17.5001V21.667Z",
    fill: "#8D8885"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGrey);
export default __webpack_public_path__ + "static/media/product-grey.7b42f4a18685e9ab8e087e73c9da6617.svg";
export { ForwardRef as ReactComponent };